export default "__VITE_ASSET__3afe32d9__"